/*eslint-disable*/
import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
function ViewButton(props) {
    let handleOpenEdit = (e) => {
        e.stopPropagation()
        let mainData = props.data
        let items =
        {
            number: mainData.number,
            refNum: mainData.refNum,
            id: mainData.id,
            appStatusId: mainData.appStatusId,
            vehnumber: mainData.vehnumber,
            total: mainData.total,
            type: mainData.type,
            vehicleIn: mainData.vehicleIn,
            vehicleOut: mainData.vehicleOut,
            vendor: mainData.vendor,

        }

        mainData.states.history.push({ pathname: '/approvals-info', state: { id: items.id, jobCardType: mainData.type, vehicleId: mainData.vehid } })
    }
    return (
        <>
            <Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="eye" color="blue" /></Button>
        </>
    )
}

export default ViewButton
